/*
 * Кнопка-ссылка рассылки из чата «ANDRESOT» и карточки важной рассылки.
 *
 * Свой адрес открывается внутри приложения, без перезагрузки: раздел и чат
 * живут в адресе, и переход по нему — обычная навигация. Чужой сайт — в новой
 * вкладке без доступа к нашему окну (`noopener`); в приложениях для Android и
 * iPhone такая ссылка сама уходит в браузер телефона.
 */

import { goto } from '$app/navigation';
import { recordBroadcastClick } from '$api/announcements';

export function openBroadcastLink(url: string, messageId?: string): void {
	// Отметка для статистики не должна задерживать и тем более отменять переход.
	if (messageId) void recordBroadcastClick(messageId).catch(() => undefined);

	let target: URL;
	try {
		target = new URL(url, window.location.href);
	} catch {
		return;
	}
	if (target.protocol !== 'https:' && target.protocol !== 'http:') return;
	if (target.origin === window.location.origin) {
		// Это полный адрес кнопки, уже включающий base приложения.
		// eslint-disable-next-line svelte/no-navigation-without-resolve
		void goto(target);
		return;
	}
	window.open(target.href, '_blank', 'noopener,noreferrer');
}
